export default __webpack_public_path__ + "static/media/add-round-outline-16px.ffe32143.svg";